var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    x1: 78.259,
    y1: 105.366,
    x2: 87.006,
    y2: 105.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 71.39,
    y1: 100.857,
    x2: 80.137,
    y2: 100.857,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 85.281,
    y1: 110.495,
    x2: 94.028,
    y2: 110.495,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 109.514,
    y1: 98.544,
    x2: 126.647,
    y2: 98.544,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 103.644,
    y1: 104.236,
    x2: 119.857,
    y2: 104.236,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 97.964,
    y1: 109.999,
    x2: 112.834,
    y2: 109.999,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 45.286,
    y1: 81.4,
    x2: 67.024,
    y2: 81.4,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 49.626,
    y1: 56.722,
    x2: 81.234,
    y2: 56.722,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 64.524,
    y1: 81.168,
    x2: 93.168,
    y2: 81.168,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 81.069,
    y1: 81.503,
    x2: 134.295,
    y2: 81.503,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 117.106,
    y1: 56.56,
    x2: 147.25,
    y2: 56.56,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 132.255,
    y1: 80.638,
    x2: 153.139,
    y2: 80.638,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 95.42,
    y1: 97.417,
    x2: 133.437,
    y2: 97.417,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 64.68,
    y1: 107.022,
    x2: 97.85,
    y2: 107.022,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb",
    "data-name": "C_BG_shellbar",
    x1: 68.565,
    y1: 104.48,
    x2: 97.9,
    y2: 104.48,
    xlinkHref: "#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M58.974 51.343V43.21M138.342 84.433v49.381H58.974V83.389M80.665 21.519h57.677v29.545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M80.668 21.518l-21.69 21.691h21.69V21.518z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M79.509 109.793l6.247-8.853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M72.64 105.284l6.247-8.853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M86.531 114.922l6.247-8.853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_3_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M110.764 93.929l14.633 9.23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_4_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M104.894 99.693l13.713 9.085"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_5_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M99.214 105.835l12.37 8.328"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_6_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M65.774 87.575L46.536 75.226"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_7_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M50.876 45.956l29.108 21.532"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_8_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M69.796 94.53l-4.022-6.745 14.672-19.978h11.472"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_9_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M117.749 67.807H92.386L82.319 82.088l8.896-.702 6.087-6.087 30.904 19.9 4.839-6.945-15.296-20.447z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_10_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M118.356 68.057L146 45.064"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_11_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M133.505 87.52l18.384-13.764"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_12_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M96.67 114.456l8.593 5.092 26.924-21.071-3.818-3.161L97.43 75.285"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_13_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M96.6 114.514l-3.629 4.917-27.041-18.847 3.863-5.97"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_14_808774742a23d0f6d78ea41a83e3442c2edab52d9879ee4a493f70d83494e9eb)",
    d: "M96.65 114.338l-3.072-8.384-15.101-10.653-8.662-.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.7f08b51ec8841f8eb8cf35b7e63d8182.svg";
export { ForwardRef as ReactComponent };